<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('labelByImei.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('labelByImei.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-mb-3 ts-flex ts-justify-end ts-space-x-3">
          <div style="width:200px">
            <label class="ts-text-xs required">{{
              $t('labelByImei.productGrade')
            }}</label>
            <select class="form-control"
							v-model="model.product_grade"
							:disabled="waiting"
							@change="onInput"
						>
              <option value="">{{ $t('select') }}</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
            <div class="validate" v-if="errors.has('product_grade')">
              {{ errors.first('product_grade') }}
            </div>
          </div>
          <div style="width:250px">
            <label class="ts-text-xs required">{{
              $t('labelByImei.imei')
            }}</label>
            <input
							v-model.trim="model.imei"
							@keyup.enter="onInput"
							:disabled="waiting"
							type="text" class="form-control" :placeholder="$t('labelByImei.scanImei')">
            <div class="validate" v-if="errors.has('imei')">
              {{ errors.first('imei') }}
            </div>
          </div>
        </div>
        <ts-preview-pdf v-model="waiting" :src="src" />
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'generateLabelByImei',
  data() {
    return {
      waiting: false,
      src: '',
      errors: new Errors(),
			model: {
				product_grade: '',
				imei: ''
			}
    }
  },
	methods: {
		...mapActions('product/label', ['printByImei']),
		onInput: debounce(function(){
				if(!this.model.imei) return
				
				this.waiting = true
				this.printByImei(this.model)
				.then((response) => {
          this.src = response.url
					this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
		}, 500),
		clearInput(){
			this.model.product_grade = ''
			this.model.imei = ''
		}
	},
}
</script>
